import BaseEntityService from "core/framework/BaseEntityService";
import env from "environment";

class NetworkService extends BaseEntityService {
  constructor() {
    super({
      baseUrl: env.baseUrl + "/networks"
    });
  }
}

const service = new NetworkService();

export default service;
